import React from "react";
import "./App.css";
import Breakout from "./games/breakout/Breakout";

function App() {
  return (
    <>
      <Breakout />
    </>
  );
}

export default App;
